import Popper from "@/components/tooltip/Popper"
import PopperProxyMixin from "@/components/tooltip/PopperProxyMixin"

export { Popper, PopperProxyMixin }

export default {
    install(Vue) {
        Vue.component("Popper", Popper)
    },
}
